import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err))
  .finally(async () => {
    const loader = document.getElementById('app-loader');
    // todo remove
    const error = document.getElementById('app-error');
    const largeDownloadedEl = document.createElement('div');
    largeDownloadedEl.id = 'large-download';
    largeDownloadedEl.style.display = 'none';
    document.body.appendChild(largeDownloadedEl);
    // todo remove

    if (loader) {
      loader.style.opacity = '0';
      loader.addEventListener(
        'transitionend',
        () => {
          loader.remove();
          // todo remove
          largeDownloadedEl?.remove();
          error?.remove();
        },
        {
          once: true,
        }
      );
    }
  });
